<template>
<b-modal v-model="showModal" @close="closedModal">
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <!-- <p class="modal-card-title">Changing password for {{ username }}</p> -->
        </header>
        <section class="modal-card-body">
            <b-field label="Set a status">
                <b-input class="status-input" v-model="status.text"></b-input>
            </b-field>

            <emoji-picker @emoji="insert" :search="search" class="emoji-parent">
                <div class="emoji-top" slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
                    <b-input class="emoji-selector" v-model="status.emoji"></b-input>
                    <!-- <button type="button">open</button> -->
                </div>
                <div class="emoji-holder" slot="emoji-picker" slot-scope="{ emojis, insert }">
                    <div>
                        <div>
                            <b-input placeholder="Search for an emoji" v-model="search"></b-input>
                        </div>
                        <div>
                            <div v-for="(emojiGroup, category) in emojis" :key="category">
                                <h5 class="emoji-title">{{ category }}</h5>
                                <div>
                                    <span class="emoji-icon" v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </emoji-picker>
        </section>
        <footer class="modal-card-foot">
            <b-button label="Close" @click="closedModal" />
            <b-button label="Clear status" @click="changeStatus(true)" />
            <b-button label="Change status" type="is-primary" @click="changeStatus(false)" />
        </footer>
    </div>
</b-modal>
</template>

<script>
import {
    EmojiPicker
} from 'vue-emoji-picker'
import UserService from '../../services/user.service';

export default {
    name: "change-status",
    props: ['setStatus'],
    data() {
        return {
            status: {
                text: '',
                emoji: '💬'
            },
            search: '',
            showModal: false
        }
    },
    components: {
        EmojiPicker
    },
    mounted() {
        this.showModal = this.setStatus
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    methods: {
        insert(emoji) {
            this.status.emoji = emoji
        },
        closedModal() {
            this.showModal = false
            this.$emit('closeChangeStatus')
        },
        changeStatus(clearStatus) {
            let status = null
            if (clearStatus) {
                this.status = {
                    text: '',
                    emoji: '💬'
                }
            } else {
                status = JSON.stringify(this.status)
            }

            UserService.changeStatus({
                    id: this.currentUser.id,
                    status
                })
                .then(() => {
                    this.$store.dispatch('auth/setUserStatus', status);
                    this.closedModal()
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: `Status changed successfully`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                })
        }
    }
}
</script>

<style>
.emoji-holder {
    position: fixed;
    max-width: 250px;
    max-height: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
    z-index: 200;
    background: white;
}

.emoji-icon {
    cursor: pointer;
}

.emoji-top {
    position: absolute;
    margin-top: -52px;
    max-width: 46px;

}

.emoji-selector>input {
    cursor: pointer;
}

.status-input>input {
    padding-left: 64px;
}
</style>
